import { IWeek } from '../types';
import { getWeekByDate } from './getWeekByDate';
import { TimeHelper } from '../../../utils';

export const getWeeksByMonth = (unix: number, timezone: string): IWeek[] => {
  const startDate = TimeHelper.getStartOfMonth(unix, timezone);
  const endDate = TimeHelper.getEndOfMonth(unix, timezone);
  const startOfFirstWeek = TimeHelper.getStartOfWeek(startDate, timezone);
  const endOfLastWeek = TimeHelper.getEndOfWeek(endDate, timezone);

  const weeks: IWeek[] = [];

  let startOfWeek = startOfFirstWeek;
  while (TimeHelper.isBefore(startOfWeek, endOfLastWeek, timezone)) {
    weeks.push(getWeekByDate(startOfWeek, timezone));
    startOfWeek = TimeHelper.addWeeks(startOfWeek, 1, timezone);
  }

  return weeks;
};
